<bs-digital-balance-header [inColumn]="inColumn" />
<div class="betslip-empty-notification betslip-scroller">
    <ng-container *msShowInEpcot="false">
        <span class="betslip-empty-notification__icon theme-info-i"></span>
        <div class="betslip-empty-notification__note_container">
            <div class="betslip-empty-notification__note_title" [innerHTML]="messages.betslipEmptyNoteTitle"></div>
            <div class="betslip-empty-notification__note_message" [innerHTML]="messages.betslipEmptyNoteMsg"></div>
        </div>
    </ng-container>
    <ng-container *msShowInEpcot="true">
        <ms-epcot-notification
            [message]="messages.betslipEmptyMsg"
            [notificationHeaderTitle]="messages.betslipEmptyHeaderTitle"
            [notificationType]="'info'" />
    </ng-container>
</div>
@if (false) {
    <span class="betslip-empty-notification__icon theme-error-i"></span>
    <ng-container *msShowInEpcot="false">
        <span class="betslip-empty-notification__message">{{ messages.noAffiliatePicks }}</span>
    </ng-container>
    <ng-container *msShowInEpcot="true">
        <ms-epcot-notification [message]="messages.noAffiliatePicks" [notificationHeaderTitle]="''" [notificationType]="'error'" />
    </ng-container>
}
<div class="betslip-empty-quick-links">
    <div class="betslip-count-quick-links-container">
        <bs-digital-count-quick-links />
    </div>
    <div class="betslip-digital-quick-links-container">
        <bs-digital-quick-links [context]="'EmptyBetslip'" />
    </div>
</div>
